import Vue from 'vue';
import Button from './Button.vue';
import LikeButton from './LikeButton.vue';

Vue.component('e-button', Button);
Vue.component('like-button', LikeButton);
